import { inject, observer } from "mobx-react";
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Input from "@material-ui/core/Input";

const styles = theme => ({
  dialogContentRoot: {
    marginTop: 20
  },
  LeftInputFieldRoot: {
    width: "32%"
  },
  RightInputFieldRoot: {
    width: "32%",
    textAlign: "center"
  },
  inputField: {
    paddingTop: 8,
    fontWeight: "bold"
  }
});

class TrimPlayDialog extends React.Component {
  constructor() {
    super();
    this.video = React.createRef();
  }

  _setPlayStartOffset = () => {
    const videoPlayer = this.video.current;
    const { trimPlayDialogStore } = this.props;
    if (videoPlayer.currentTime === videoPlayer.duration) return;

    videoPlayer.pause();
    trimPlayDialogStore.startOffset = videoPlayer.currentTime;

    if (trimPlayDialogStore.startOffset >= trimPlayDialogStore.endOffset) {
      trimPlayDialogStore.endOffset = videoPlayer.duration;
    }
  };

  _setPlayEndOffset = () => {
    const videoPlayer = this.video.current;
    const { trimPlayDialogStore } = this.props;
    if (videoPlayer.currentTime === 0) return;

    videoPlayer.pause();
    trimPlayDialogStore.endOffset = videoPlayer.currentTime;

    if (trimPlayDialogStore.startOffset >= trimPlayDialogStore.endOffset) {
      trimPlayDialogStore.startOffset = 0;
    }
  };

  _save = () => {
    const { trimPlayDialogStore } = this.props;
    const videoPlayer = this.video.current;
    trimPlayDialogStore.save(videoPlayer.duration);
  };

  _onEntering = () => {
    if (this.video.current) {
      this.video.current.addEventListener("loadedmetadata", () => {
        const videoPlayer = this.video.current;
        const { trimPlayDialogStore } = this.props;
        if (trimPlayDialogStore.startOffset > 0) {
          videoPlayer.currentTime = trimPlayDialogStore.startOffset;
        }
        if (trimPlayDialogStore.endOffset === 0) {
          trimPlayDialogStore.endOffset = videoPlayer.duration;
        }
      });
    }
  };

  render() {
    const { classes, trimPlayDialogStore } = this.props;

    return (
      <Dialog
        maxWidth={false}
        open={trimPlayDialogStore.isOpen}
        TransitionProps={{
          onEntering: () => this._onEntering(),
          onExited: () => trimPlayDialogStore.clear(),
          onClose: () => (trimPlayDialogStore.isOpen = false)
        }}
        aria-label="Trim Play"
      >
        <DialogContent classes={{ root: classes.dialogContentRoot }}>
          <video
            ref={this.video}
            src={trimPlayDialogStore.src}
            width="960"
            height="540"
            type="video/mp4"
            controls
          />
          <Grid container style={{ marginTop: "1rem" }}>
            <Grid item sm={5}>
              <Grid container spacing={4}>
                <Grid item sm={4}>
                  <Button
                    variant="contained"
                    onClick={this._setPlayStartOffset}
                    color="default"
                  >
                    Set Start
                  </Button>
                </Grid>
                <Grid item sm={8}>
                  <Input
                    classes={{
                      root: classes.LeftInputFieldRoot,
                      input: classes.inputField
                    }}
                    type={"string"}
                    disabled={true}
                    value={trimPlayDialogStore.startOffsetDisplay}
                    styles={{ paddingTop: 0 }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm={2} style={{ textAlign: "center" }}>
              <Button variant="contained" onClick={this._save} color="primary">
                Save
              </Button>
            </Grid>
            <Grid item sm={5}>
              <Grid container style={{ textAlign: "right" }} spacing={0}>
                <Grid item sm={9} style={{ paddingRight: "6%" }}>
                  <Input
                    classes={{
                      root: classes.RightInputFieldRoot,
                      input: classes.inputField
                    }}
                    type={"string"}
                    disabled={true}
                    value={trimPlayDialogStore.endOffsetDisplay}
                    styles={{ paddingTop: 0 }}
                  />
                </Grid>
                <Grid item sm={3}>
                  <Button
                    variant="contained"
                    onClick={this._setPlayEndOffset}
                    color="default"
                  >
                    Set End
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    );
  }
}

export default inject("trimPlayDialogStore")(
  withStyles(styles)(observer(TrimPlayDialog))
);



// WEBPACK FOOTER //
// ./src/components/TrimPlayDialog.js